import ApiGetOptions from '@/datatypes/api-get-options';
import ApiPostOptions from '@/datatypes/api-post-options';
import ApiDeleteOptions from '@/datatypes/api-delete-options';
import ApiService from '@/services/api/ApiService';
import decamelizeKeysDeep from 'decamelize-keys-deep';

export default class SubscriptionService extends ApiService {
  public create(enterpriseId, options) {
    return this.call(new ApiPostOptions(
      {
        url: `/enterprises/${enterpriseId}/subscription`,
        data: decamelizeKeysDeep(options),
      },
    ));
  }

  public remove(enterpriseId) {
    return this.call(new ApiDeleteOptions(
      {
        url: `/enterprises/${enterpriseId}/subscription`,
      },
    ));
  }

  public listSubscriptionTypes() {
    return this.call(new ApiGetOptions(
      {
        url: '/subscription_types',
      },
    ));
  }

  public showSubscriptionType(subscriptionType) {
    return this.call(new ApiGetOptions(
      {
        url: `/subscription_types/${subscriptionType}`,
      },
    ));
  }

  public list(params) {
    return this.call(new ApiGetOptions(
      {
        url: '/subscriptions',
        params,
      },
    ));
  }

  public show(subscriptionId) {
    return this.call(new ApiGetOptions(
      {
        url: `/subscriptions/${subscriptionId}`,
      },
    ));
  }

  public assign(enterpriseId, subscriptionParams) {
    return this.call(new ApiPostOptions(
      {
        url: `/enterprises/${enterpriseId}/subscription/assign`,
        data: decamelizeKeysDeep(subscriptionParams),
      },
    ));
  }
}
